
import React from 'react';
import { siteConfig } from '../config/site';
import { CheckCircle2, Clock, MapPin, Zap } from 'lucide-react';
import { useLanguage } from '../App';

const Services: React.FC = () => {
  const service = siteConfig.services[0];
  const { t, openBooking } = useLanguage();

  return (
    <section id="services" className="py-20 sm:py-32 px-4 sm:px-6 bg-primary relative overflow-hidden">
      <div className="max-w-5xl mx-auto relative z-10">
        <div className="text-center mb-20 reveal reveal-up active">
          <h3 className="text-accent font-black tracking-[0.4em] uppercase text-[10px] mb-4">{t.exclusiveOffering}</h3>
          <h2 className="text-4xl sm:text-6xl font-serif font-bold mb-8 leading-tight tracking-tight uppercase">{t.signatureHouseCall}</h2>
          <div className="w-16 h-px bg-accent/20 mx-auto mb-8"></div>
          <p className="text-white/40 max-w-xl mx-auto italic font-light leading-relaxed text-base sm:text-lg px-2">
            {t.experienceDesc}
          </p>
        </div>

        <div className="bg-secondary/20 backdrop-blur-xl border border-white/5 p-6 sm:p-20 relative group shadow-3xl hover:border-accent/10 transition-all duration-700">
          <div className="absolute top-0 right-0 bg-accent text-black px-8 py-3 font-black uppercase tracking-[0.2em] text-[10px] sm:text-xs z-20 shadow-2xl">
            ${service.price}
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 sm:gap-20 items-start">
            <div className="space-y-10 reveal reveal-left active">
              <div className="space-y-4">
                <h4 className="text-2xl sm:text-3xl font-serif font-bold text-white uppercase tracking-wider leading-tight">{t.signatureHouseCall}</h4>
                <p className="text-white/50 leading-relaxed text-sm sm:text-base font-light italic">
                  Concierge level barbering at your chosen location. The shop comes to you.
                </p>
              </div>

              <div className="flex flex-wrap gap-8">
                <div className="flex items-center gap-3 text-white/40 text-[10px] font-black uppercase tracking-[0.2em]">
                  <Clock className="text-accent/60" size={18} />
                  <span>{service.duration}</span>
                </div>
                <div className="flex items-center gap-3 text-white/40 text-[10px] font-black uppercase tracking-[0.2em]">
                  <MapPin className="text-accent/60" size={18} />
                  <span>{t.southFlorida}</span>
                </div>
              </div>
            </div>

            <div className="space-y-8 md:border-l border-white/5 md:pl-16 reveal reveal-right active pt-8 md:pt-0">
              <h5 className="text-[10px] font-black text-accent/50 uppercase tracking-[0.3em] mb-4">{t.includedHeader}</h5>
              <ul className="space-y-4 sm:space-y-5">
                {t.includedItems.map((item: string, i: number) => (
                  <li key={i} className="flex items-center gap-4 text-[12px] sm:text-[14px] text-white/70 transition-transform hover:translate-x-2 duration-500 group/item">
                    <CheckCircle2 size={16} className="text-accent/40 group-hover/item:text-accent transition-colors shrink-0" />
                    <span className="font-light tracking-wide">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-16 sm:mt-20 flex flex-col sm:flex-row gap-8 items-center justify-between border-t border-white/5 pt-12 reveal reveal-up active">
            <div className="flex items-center gap-3 text-white/30 italic text-[11px] font-light">
              <Zap size={18} className="text-accent/30" />
              <span>{t.mobileSetupNote}</span>
            </div>
            <button 
              onClick={openBooking}
              className="w-full sm:w-auto px-16 py-6 bg-accent text-black hover:bg-white transition-all duration-700 font-black uppercase tracking-[0.2em] text-[10px] text-center shadow-2xl"
            >
              {t.bookTheCall}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
